/**
 * Whether `PackageItineraryReview`'s mount effect should defer dispatching
 * `finalizePackage`: only under v2, while `searchKey` hasn't resolved into Redux
 * yet.
 *
 * `PackageItineraryReview` is rendered as a child of `Body`, whose own mount
 * effect is what hydrates `packageIdentity.searchKey` from the `packageSearchKey`
 * URL param (see `App.tsx`). React fires child mount effects before parent mount
 * effects within the same commit, so on Review's initial mount, `searchKey` can
 * still be `null` in Redux even though it's already present in the URL. Firing
 * `finalizePackage` before `searchKey` resolves would call the v2 finalize saga
 * with no `searchKey` to key off of. Deferring until it resolves (and re-firing
 * once it does, via the effect's dependency array) mirrors the same guard
 * `DesktopPackagesBookWorkflow`/`MobilePackagesBookWorkflow` already use before
 * triggering `pollPackageVersion`.
 */
export const shouldDeferFinalizePackage = (args: {
  isV2Enabled: boolean;
  searchKey: string | null;
}): boolean => args.isV2Enabled && args.searchKey == null;
